import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { GenericDialogLayout } from '../../GenericDialogLayout'
import { ShowDialogProps } from 'src/show-dialog'
import { DocumentCategoryForm } from '../../../screens/admin/document-category/DocumentCategoryForm'
import { invalidateDocumentCategoryCache, useAddDocumentCategory } from '../../../api/document-category'
import { invalidateCustomerDocumentCategoryCache } from 'src/api/customer-document-category'
import { toast } from 'react-toastify'

export const CreateDocumentCategoryDialog: React.FC<ShowDialogProps> = ({ pop }) => {
  const { t: translate } = useTranslation(['document-category', 'common'])
  const mutation = useAddDocumentCategory()

  const onSubmit = useCallback(
    async form => {
      await mutation.mutateAsync(form, {
        onSuccess: () => {
          toast.success(translate('successfullyAdded', { ns: 'common-api-message' }))
          invalidateDocumentCategoryCache.useGetDocumentCategories()
          invalidateCustomerDocumentCategoryCache.getCustomerAndAdminDocumentCategories()
          pop(true)
        },
        onError: error => {
          if (error && error['data'] === 'DocumentCategoryAlreadyExists') {
            toast.warning(translate('documentCategoryAlreadyExists', { ns: 'document-category' }))
          } else {
            toast.error(translate('CannotAddDocumentCategory', { ns: 'document-category' }))
          }
        },
      })
    },
    [mutation, translate, pop],
  )

  return (
    <GenericDialogLayout title={translate('addDocumentCategory', { ns: 'document-category' })} pop={pop}>
      <DocumentCategoryForm onSubmit={onSubmit} onCancel={() => pop()} />
    </GenericDialogLayout>
  )
}
